module.exports = __webpack_public_path__ + "img/5ggameicon.291867f8.png";